import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { EntitiesStructure } from 'common/types/Page'
import ServerPage from 'src/shared/types/server-page-interface'

//run the command only on page level, not on layout

export const removeDuplicatedBlogPostLayoutBody = (
  page: ServerPage,
): [ServerPage, boolean] => {
  if (page.type !== PageTypeEnum.BlogPostBody) return [page, false]

  let hasChanged = false

  const newEntities: EntitiesStructure = {}

  for (const entity of Object.values(page.content.entities)) {
    if (
      entity.type === EntityTypeEnum.BlogPostLayoutBody &&
      !('isReadOnly' in entity)
    ) {
      hasChanged = true
      continue
    }

    newEntities[entity.id] = entity
  }

  return [
    {
      ...page,
      content: {
        ...page.content,
        entities: newEntities,
      },
    },
    hasChanged,
  ]
}
